import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { LoadableFallback } from 'components/Common/LoadableFallback';

const RequestHistory = loadable(() => import(/* webpackChunkName: "RequestHistory" */ './RequestHistory'), {
  fallback: <LoadableFallback visible />,
});

const asyncRequestHistory = ({ route }) => (
  <RequestHistory route={route} />
);

asyncRequestHistory.propTypes = {
  route: PropTypes.object.isRequired,
};

export default asyncRequestHistory;
